/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-param-reassign */
import { Center, Stack, HStack, Button, Box, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdContentCopy } from 'react-icons/md';
import { CopyTooltip } from '../formComponentSidebar/FormBuilderTags';
import { generateFormSchema } from '../utils/generateFormSchema';
import { FORM_ADVANCED_SECTIONS } from '../schemas/formAdvancedSections';
import { FormFieldT } from '../types';
import { COMPONENT_FIELDS } from '../schemas/formComponentFieldSchema';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from '../schemas/formComponentInputTypeSchema';
import { flattenToFormFields } from '../utils';
import JsonViewer from './JsonViewer';
import { useStoreState } from '../../../../models/hooks';

function JsonPreviewComponent() {
  const { t, i18n } = useTranslation('hrFormTemplate');
  const formSchema = useStoreState((state) => state.formBuilder.formSchema);
  const fieldAnswerMap = {
    firstName: t('jsonAnswer.firstName'),
    middleName: t('jsonAnswer.middleName'),
    lastName: t('jsonAnswer.lastName'),
    nickname: t('jsonAnswer.nickname'),
    email: 'davyjones@appyhere.com',
    gender: t('jsonAnswer.gender'),
    dateOfBirth: '2022-11-15T02:18:38.925Z',
    correspondenceLanguage: 'french',
    phoneNumber: '+16045555551',
    optionalPhoneNumber: t('jsonAnswer.optionalPhoneNumber'),
    socialInsuranceNumber: '731-328-530',
    workPermitType: t('jsonAnswer.workPermitType'),
    completeAddress: t('jsonAnswer.completeAddress'),
    address: {
      addressLineOne: t('jsonAnswer.address.addressLineOne'),
      addressLineTwo: t('jsonAnswer.address.addressLineTwo'),
      city: t('jsonAnswer.address.city'),
      region: t('jsonAnswer.address.region'),
      postalCode: 'M5G 0A8',
      country: t('jsonAnswer.address.country'),
    },
    emergencyContact: {
      firstName: t('jsonAnswer.emergencyContact.firstName'),
      lastName: t('jsonAnswer.emergencyContact.lastName'),
      phoneNumber: '+16045555553',
    },
    signatureImageUrl: 'https://appyhere.com/signatureImageUrl',
    chequebookImageUrl: [
      'https://appyhere.com/chequebookImageUrl',
      'https://appyhere.com/chequebookImageUrl',
      'https://appyhere.com/chequebookImageUrl',
    ],
    documentIdImageUrl: ['https://appyhere.com/documentIdImageUrl', 'https://appyhere.com/documentIdImageUrl'],
    workPermitImageUrl: ['https://appyhere.com/workPermitImageUrl', 'https://appyhere.com/workPermitImageUrl'],
    workPermitEndDate: '2022-11-15T02:18:38.925Z',
    miscellaneous: { contractDetailsWordings: t('jsonAnswer.miscellaneous.contractDetailsWordings') },
    canadianBankAccountDetails: { branchTransitNumber: '12345', financialInstitutionNumber: '123', bankAccountNumber: '1234567' },
    americanBankAccountDetails: { routingNumber: '12345', bankAccountNumber: '1234567' },
    date: '2022-11-15T02:18:38.925Z',
    image: ['https://appyhere.com/image'],
    pdfUrl: 'https://appyhere.com/pdfUrl',
    completedAt: '2022-11-15T02:18:38.925Z',
    consentViewedDate: '2022-11-15T02:18:38.925Z',
    consentAcceptedDate: '2022-11-15T02:18:38.925Z',
    requisitionId: 'RequisitionId-1234',
    createdAt: '2022-11-15T02:18:38.925Z',
    updatedAt: '2022-11-15T02:18:38.925Z',
    apartment: '123',
    text: t('jsonAnswer.text'),
    number: 123,
    phone: '+11234567890',
    yesNo: t('jsonAnswer.yesNo'),
  } as Record<string, any>;
  const removeFields = [
    FORM_COMPONENT_BASIC_INPUT_TYPE.info,
    FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable,
    FORM_COMPONENT_BASIC_INPUT_TYPE.button,
  ];

  const baseData: Record<string, any> = {
    id: '032KJ7g19tteWyiGvkKJ875FB3Z8XugH',
    employeeId: t('jsonAnswer.employeeId'),
    recruiterFullName: t('jsonAnswer.recruiterFullName'),
    type: 'NEW_HIRE',
    positionName: t('jsonAnswer.positionName'),
    business: {
      name: t('jsonAnswer.business.name'),
      country: t('jsonAnswer.business.country'),
      address: t('jsonAnswer.business.address'),
      locationId: '5gyyb0b3-35u2-41i2-b01d-7e74766gry',
    },
    job: '123',
    startingDate: '2022-11-15T02:18:38.925Z',
    note: t('jsonAnswer.note'),
    wage: { unit: 'hourly', value: 2522, customUnit: 'weekly' },
    fullTime: true,
    endDate: '2022-12-15T02:18:38.925Z',
    partTimeHours: 19.15,
  };

  const handleBankFields = (acc: Record<string, any>, question: any, field: string) => {
    const fieldName =
      question.section === FORM_ADVANCED_SECTIONS.americanBank ? 'americanBankAccountDetails' : 'canadianBankAccountDetails';

    acc[fieldName] = {
      ...(acc[fieldName] || {}),
      [field]: fieldAnswerMap[fieldName]?.[field],
    };
  };

  const handleSimpleFields = (acc: Record<string, any>, question: any) => {
    if (removeFields.includes(question.inputType)) return;
    if (question?.inputType === FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo && question?.followUpQuestionList?.length > 0) return;

    if (question?.documentReview) {
      // acc['documentIdImageUrl'] = [question?.documentReview.url[i18n.language]];
      acc[question.field] = '2022-11-15T02:18:38.925Z';
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      acc[`${question.field}ViewedDate`] = '2022-11-15T02:18:38.925Z';
    } else {
      acc[question.field] = fieldAnswerMap[question.field?.split('_')[0]];
    }
  };

  const handleOptions = (acc: Record<string, any>, question: any) => {
    switch (question.inputType) {
      case FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox:
        acc[question.field] = [question?.optionList?.[0]?.text[i18n.language]];
        break;
      case FORM_COMPONENT_BASIC_INPUT_TYPE.radio:
        acc[question.field] = question?.optionList?.[0]?.text[i18n.language];
        break;
      case FORM_COMPONENT_BASIC_INPUT_TYPE.text:
        if (question.field !== COMPONENT_FIELDS.addressLineTwo) {
          acc[question.field] = fieldAnswerMap[question.inputType];
        }
        break;
      case FORM_COMPONENT_BASIC_INPUT_TYPE.image:
      case FORM_COMPONENT_BASIC_INPUT_TYPE.number:
      case FORM_COMPONENT_BASIC_INPUT_TYPE.email:
      case FORM_COMPONENT_BASIC_INPUT_TYPE.phone:
      case FORM_COMPONENT_BASIC_INPUT_TYPE.date:
      case FORM_COMPONENT_BASIC_INPUT_TYPE.signature:
        acc[question.field] = fieldAnswerMap[question.inputType];
        break;
      case FORM_COMPONENT_BASIC_INPUT_TYPE.address:
        if (question.field !== FORM_COMPONENT_BASIC_INPUT_TYPE.address) {
          const ans = { ...fieldAnswerMap[question.inputType] };
          delete ans.addressLineTwo;
          acc[question.field] = ans;
        } else {
          acc[question.field] = fieldAnswerMap[question.inputType];
        }
        break;
      default:
        handleSimpleFields(acc, question);
        break;
    }
  };

  const handleFollowUpQuestions = (acc: Record<string, any>, followUps: any[]) => {
    followUps.forEach((followUp) => {
      if (
        [
          COMPONENT_FIELDS.emergencyContactFirstName,
          COMPONENT_FIELDS.emergencyContactLastName,
          COMPONENT_FIELDS.emergencyContactPhoneNumber,
        ].includes(followUp.field)
      ) {
        const fieldMap = {
          [COMPONENT_FIELDS.emergencyContactFirstName]: 'firstName',
          [COMPONENT_FIELDS.emergencyContactLastName]: 'lastName',
          [COMPONENT_FIELDS.emergencyContactPhoneNumber]: 'phoneNumber',
        } as Record<string, string>;

        acc[COMPONENT_FIELDS.emergencyContact] = {
          ...(acc[COMPONENT_FIELDS.emergencyContact] || {}),
          [fieldMap[followUp.field]]: fieldAnswerMap[COMPONENT_FIELDS.emergencyContact]?.[fieldMap[followUp.field]],
        };
      } else if (followUp.field === COMPONENT_FIELDS.signature) {
        acc['signatureImageUrl'] = fieldAnswerMap['signatureImageUrl'];
      } else {
        handleOptions(acc, followUp);
      }
    });
  };

  const questions = generateFormSchema(formSchema, 'en')?.reduce((acc, question) => {
    switch (question.field) {
      case COMPONENT_FIELDS.contractDetailsWordings:
        acc['miscellaneous'] = fieldAnswerMap['miscellaneous'];
        break;
      case COMPONENT_FIELDS.routingNumber:
      case COMPONENT_FIELDS.bankAccountNumber:
      case COMPONENT_FIELDS.branchTransitNumber:
      case COMPONENT_FIELDS.financialInstitutionNumber:
        handleBankFields(acc, question, question.field);
        break;
      case COMPONENT_FIELDS.signature:
        acc['signatureImageUrl'] = fieldAnswerMap['signatureImageUrl'];
        break;
      default:
        handleOptions(acc, question);
        break;
    }

    if (question?.followUpQuestionList?.length) {
      handleFollowUpQuestions(acc, question.followUpQuestionList);
    }

    return acc;
  }, baseData);

  const comments = React.useMemo(() => {
    return flattenToFormFields(formSchema)?.reduce((acc, question) => {
      const key = question.field;
      acc[key] = question;
      // if (question.field !== question?.label?.[i18n.language]) {
      // } else
      //   if (question?.followUpQuestionList?.length) {
      //     question.followUpQuestionList.forEach((followUp) => {
      //       let followupKey = followUp.field;
      //       const followUpLabel = followUp?.label?.[i18n.language];
      //       if (followupKey !== followUpLabel) {
      //         acc[followupKey] = followUp;
      //       }
      //     });
      //   }
      return acc;
    }, {} as Record<string, FormFieldT>);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions]);

  return (
    <Center flexGrow={1} minH={0} h="100%">
      <Stack minH={0} padding={1} height="100%" borderRadius="20px" boxShadow="0 0 43.31px #00000026" width="100%">
        <HStack justify="flex-end" padding={3} pb={0}>
          <CopyTooltip
            copyText={JSON.stringify(questions, null, 2)}
            gutter={5}
            placement="bottom-end"
            wrapperStyle={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1, maxWidth: '12rem' }}
            contentStyle={{ maxWidth: 'auto' }}
          >
            <Button
              as={Box}
              size="sm"
              variant="outline"
              leftIcon={<MdContentCopy color="blue" />}
              colorScheme="gray"
              cursor="pointer"
            >
              <Text color="blue !important">{t('templateListView.tableActions.copy')}</Text>
            </Button>
          </CopyTooltip>
        </HStack>
        <Box
          flexGrow={1}
          minH={0}
          height="100%"
          overflowY="auto"
          overflowX="auto"
          padding={3}
          pt={0}
          sx={{
            '&::-webkit-scrollbar': { width: '3px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'darkgrey', borderRadius: '10px' },
          }}
        >
          <Box sx={{ '.string-value': { wordBreak: 'break-all' } }}>
            <JsonViewer data={questions} comments={comments} />
          </Box>
        </Box>
      </Stack>
    </Center>
  );
}

export const JsonPreview = React.memo(JsonPreviewComponent, () => true);
